import './style.scss';
import { init } from './scripts/init';

document.addEventListener('DOMContentLoaded', () => init('nav_primary', 100));
